import * as React from "react";
import { SvgShapeComponent, ToolType } from "../../types/Floorplan.types";

export interface IPreviewShapeProps {
    tempShape?: SvgShapeComponent[];
    selectedShapeIdx?: number;
    selectedTool?: ToolType;
}

const PreviewShape = (props: IPreviewShapeProps) => {
    const { tempShape, selectedShapeIdx, selectedTool } = props;

    const getPath = React.useCallback((shapeElements: SvgShapeComponent[]) => {
        return shapeElements.map((shape) => {
            let pathEl = "";
            switch (shape.type) {
                case "Move":
                    pathEl = `M ${shape.x} ${shape.y}`;
                    break;
                case "Line":
                    pathEl = `L ${shape.x} ${shape.y}`;
                    break;
                case "Curve":
                    pathEl = `Q ${shape.x1} ${shape.y1} ${shape.x} ${shape.y}`;
                    break;
                case "ReflectedCurve":
                    pathEl = `T ${shape.x} ${shape.y}`;
                    break;
                case "Closure":
                    pathEl = "Z";
                    break;
            }
            return pathEl;
        }).join(' ');
    }, []);

    if (tempShape && tempShape.length > 0) {
        return <>
            { tempShape !== undefined && tempShape.length > 0 && (
                <g id="tempShape">
                    <g className="tempShape">
                        <path d={getPath(tempShape)} />
                    </g>
                </g>
            )}
        </>;
    }
    return null;
};

export default PreviewShape;